import React, { Component } from 'react';
import { connect } from 'react-redux';
import Header from '../../common_components/Header';
import Drawer from '../../common_components/Drawer';
import { lastSubmitAdd_action } from '../../actions/last_submit_action'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { withRouter } from '../../utils/withRouter';
import moment from 'moment';
import Modal from "react-modal";
import Loader from '../../utils/Loader'
import { clearSessionStorage, countryActionId, toastError, toastSuccess, countryIWithCodeActionId, timeout } from '../../utils/constants'
import Pagination from '../../utils/pagination'
import { useEffect, useState } from 'react';
import { useNavigate, Link } from "react-router-dom";
import { fill_action } from '../../actions/fillCombo_action'
import StepHeader from './stepHeader'
import Footer from '../../common_components/Footer';
import $ from 'jquery'


class LastSubmit extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isLoading: false,
            geturl: ""
        }

        this.onSubmit = this.onSubmit.bind(this)
        this.onPreviousClick = this.onPreviousClick.bind(this)
        this.loadscript = this.loadscript.bind(this)
    }

    onSubmit(e) {
        var exbid = sessionStorage.getItem("sessionExhibitionID");
        var regid = sessionStorage.getItem("sessionExhRegistrationID")

        this.setState({ isLoading: true })
        this.props
            .lastSubmitAdd_action(exbid, regid)
            .then((data) => {
                this.setState({ isLoading: false })
                if (data.error != 1) {
                    this.props.navigate('/thankYou')

                    // toastSuccess("Your space booking application has been submitted successfully.");
                }
                else {
                    toastError(data.msg)
                }
            })
            .catch((e) => {
                console.log(e);
            });

    }

    componentDidMount() {
        this.setState({ isLoading: true })
        sessionStorage.setItem("renderPage", "summary")
        this.setState({
            geturl: this.props.location.state != null && this.props.location.state != "" && this.props.location.state.geturl != " " ? this.props.location.state.geturl : '',
        })
        setTimeout(() => {
            this.setState({ isLoading: false })
        }, 5000);
        this.loadscript()
    }

    loadscript(){
        $(document).ready(function(){
            $(this).scrollTop(0);
        });
    }

    onPreviousClick() {
        sessionStorage.setItem("renderPage", "description")
        this.props.navigate('/description', { state: { is_update: true } })
    }

    render() {
        const { isLoading, geturl } = this.state

        return (
            <>
                {isLoading ? (
                    <Loader></Loader>
                ) : (null)}
                <ToastContainer />
                {/* <!-- PAGE --> */}

                <Header />
                {/* <!-- CONTAINER --> */}
                <div className="page-height" style={{ height: 'auto' }}>
                    <div className="main-container container-fluid">

                        {/* <StepHeader /> */}

                        {/* <!-- ROW-1 --> {geturl}*/}
                        <div className="row ">
                            <div className="col-lg-12 col-md-12 col-sm-12 col-xl-12">
                                <div className="row ">

                                    <form className="needs-validation " novalidate="">
                                        <div className="form-row mt-4">

                                            <iframe
                                                id="myIframe"
                                                src={geturl}
                                                width="400px"
                                                height="400px"
                                                title="Bing"
                                            />
                                            {/* <div className="main-container container-fluid p-3 pt-0 pb-0">
                                                                <div className="mt-1 mb-4">
                                                                    <button className="btn apply-btn mt-2" type="submit">
                                                                        <a className="text-center " onClick={e => this.onSubmit(e)}>Submit</a>
                                                                    </button>
                                                                </div>
                                                            </div> */}

                                            <div class="mt-2 submit-center for-mob-bot-spc" role="group" aria-label="Basic example" style={{marginBottom : '100px !important'}}>
                                                <button className="btn btn-previous" style={{ marginRight: '10px' }} type="submit" onClick={e => this.onPreviousClick(e)}>
                                                    Previous
                                                </button>
                                                <button type="button" class="btn btn-previous" onClick={e => this.onSubmit(e)}>Submit</button>
                                            </div>
                                            
                                            <Footer/>
                                            <div style={{height:'80px'}}></div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
                {/* <Footer/> */}
                {/* <!-- CONTAINER END --> */}

            </>
        );
    }
}

export default withRouter(connect(null, {
    lastSubmitAdd_action
})(LastSubmit));

